import { render, staticRenderFns } from "./ActivityCard.vue?vue&type=template&id=3a963458&scoped=true"
import script from "./ActivityCard.vue?vue&type=script&lang=js"
export * from "./ActivityCard.vue?vue&type=script&lang=js"
import style0 from "./ActivityCard.vue?vue&type=style&index=0&id=3a963458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a963458",
  null
  
)

export default component.exports